import markdownContent from '!!raw-loader!static/health_benefit.md';
import { Markdown } from 'Common';

export const HealthBenefitPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default HealthBenefitPage;
